// this file is copied from backend
// https://github.com/Lyearn/lyearn-resource-service/blob/82171c08c3adf90c330f93c603dcfc47681371cc/src/services/event/utils/recurringEventNextOccurrences.util.ts
// not using directly from backend due to internal dependencies on rpc-contract

import isEqual from 'date-fns/isEqual';

import { EndScheduleTypeEnum, ScheduleInfo } from '@/types/schema';

import {
  getNextOccurrenceDateFromSchedule,
  getNextOccurrenceDatesInDateRangeFromSchedule,
} from './getNextOccurrenceDateFromSchedule';

export function isDateInFuture(startTime: string): boolean {
  const currentDateTime = new Date(); // Current date and time
  const startDateTime = new Date(startTime); // Convert startTime string to Date object

  return startDateTime > currentDateTime;
}

export function isStartDatePartOfSchedule(schedule: ScheduleInfo, startDate: string): boolean {
  const nextOccurrenceDate = getNextOccurrenceDateFromSchedule({
    schedule,
    options: { startDate, includeStartDate: true },
    count: 1,
  });
  return isEqual(new Date(startDate), new Date(nextOccurrenceDate[0]));
}

// IF occurrencesCount is not provided, then return all occurrences as per endScheduleInfo
// Any Occurrence that is not in the future will not be returned
export function getNextOccurrences(
  schedule: ScheduleInfo,
  startDate?: string,
  occurrencesCount?: number,
): string[] {
  const { endScheduleInfo } = schedule;
  if (!endScheduleInfo) {
    return [];
  }
  const { endScheduleType, date, numberOfOccurrences } = endScheduleInfo;
  const nextOccurrenceDates: Array<string> = [];
  let newStartDate = startDate;

  if (
    newStartDate &&
    isStartDatePartOfSchedule(schedule, newStartDate) &&
    isDateInFuture(newStartDate)
  ) {
    nextOccurrenceDates.push(newStartDate);
  }

  if (occurrencesCount) {
    let toCreateOccurrencesCount = occurrencesCount;
    if (nextOccurrenceDates.length > 0) {
      toCreateOccurrencesCount = occurrencesCount - nextOccurrenceDates.length;
    }

    const allNextOccurrenceDates = getNextOccurrenceDateFromSchedule({
      schedule,
      options: { startDate: newStartDate },
      count: toCreateOccurrencesCount,
    });

    return [...nextOccurrenceDates, ...allNextOccurrenceDates];
  }
  if (endScheduleType === EndScheduleTypeEnum.Date && date) {
    const occurrences = getNextOccurrenceDatesInDateRangeFromSchedule({
      schedule,
      options: { startDate: startDate ?? new Date().toISOString(), endDate: date },
    });
    for (const occurrence of occurrences) {
      if (isDateInFuture(occurrence)) {
        nextOccurrenceDates.push(occurrence);
      }
    }
    return nextOccurrenceDates;
  }

  if (endScheduleType === EndScheduleTypeEnum.Occurrences && numberOfOccurrences) {
    let toCreateOccurrencesCount = numberOfOccurrences;
    if (nextOccurrenceDates.length > 0) {
      toCreateOccurrencesCount = numberOfOccurrences - nextOccurrenceDates.length;
    }

    const allNextOccurrenceDates = getNextOccurrenceDateFromSchedule({
      schedule,
      options: { startDate: newStartDate },
      count: toCreateOccurrencesCount,
    });

    return [...nextOccurrenceDates, ...allNextOccurrenceDates];
  }

  return nextOccurrenceDates;
}
